<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-09 16:24:35
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-10-09 17:03:01
-->
<template>
	<el-dialog title="提示" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
		<p class="yx-color-text-primary">
			<i class="el-icon-info"></i>
			是否确认继续操作？</p
		>
		<p class="mt-8 fz-14 yx-color-pure-1">规则修改保存后新产生的订单将按最新规则判断业绩归属，历史未归属订单将在0点按最新规则更新归属。</p>
		<span slot="footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="save">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'saveDialog',
	data() {
		return {
			dialogVisible: false,
		};
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
		cancel() {
			this.handleClose();
		},
		save() {
			this.$emit('save');
			this.handleClose();
		},
	},
};
</script>

<style lang="less" scoped>
/deep/.el-icon-info:before {
	content: '\E7A1';
	color: #ff7038 !important;
}
</style>
